import { AnnotationDirective, Annotations, AnnotationsDirective, AxesDirective, AxisDirective, Inject, LinearGaugeComponent, PointerDirective, PointersDirective } from '@syncfusion/ej2-react-lineargauge';
import React from 'react';
import Constants from '../../models/constants';
import { RatingRange, trackRatingMap } from '../../models/trackRatingMap';
import Weather from '../../models/weather';
import './soilcompression.css';

const SoilCompression: React.FC<{weather: Weather}> = ({weather}) => {
    const rate = weather.goingStick?.thisMeeting?.trackRating ?? 0;
    const goingStick =weather.goingStick?.thisMeeting?.goingStick ?? 0;
    const goingStickStr = goingStick !== 0? goingStick.toFixed(1) : '―';
    const penetrometer =weather.goingStick?.thisMeeting?.penotrometer ?? 0;
    const penetrometerStr = penetrometer !== 0? penetrometer.toFixed(2) : '―';
    const ratingMap: RatingRange[] = trackRatingMap.filter(t => t.range[0] <= rate && t.range[1] >= rate);
    const ratingStr: string = ratingMap.length > 0 ? ratingMap[0].rating : '―';
    const gaugeColor: string = ratingStr === 'Firm' ? '#0085C0' : 'Good' ?  '#00961E' : 'Soft' ? '#F8DE00' : 'Heavy' ? '#FF9700' : 'gray';

    return (
        <div className="soil-compression-container">
            <div className='soil-compression-title'>
                Soil Compression
            </div>
            <div className='soil-compression-gauge-pair'>
                {weather.jurisdiction === 'atc' && (
                    <LinearGaugeComponent
                    className='soil-compression-component'
                    container={{ width: 15, type: 'RoundedRectangle', backgroundColor: Constants.darkBlue }}
                    background={Constants.grey}
                    >
                    <Inject services={[Annotations]} />
                    <AxesDirective>
                        <AxisDirective
                        maximum={15}
                        minimum={4}
                        majorTicks={{ height: 0 }}
                        minorTicks={{ height: 0 }}
                        labelStyle={{ font: { size: '0' } }}
                        line={{ width: 0 }}
                        >
                        <PointersDirective>
                            <PointerDirective value={goingStick} width={15} type='Bar' color={gaugeColor}>
                            </PointerDirective>
                        </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'15'} x={37} y={15} zIndex='1'>
                        </AnnotationDirective>
                        <AnnotationDirective content={'4'} x={37} y={210} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                    </LinearGaugeComponent>
                )}
                {weather.jurisdiction === 'atc' ? (
                    <div className='soil-compression-texts-between'>
                    <div className='big-text'>
                        Going Stick
                    </div>
                    <div className='large-text'>
                        {goingStickStr}
                    </div>
                    <div className='small-text'>
                        {ratingStr}
                    </div>
                    <div className='big-text'>
                        Penetrometer
                    </div>
                    <div className='large-text'>
                        {penetrometerStr}
                    </div>
                    </div>
                ) : (
                    <div className='soil-compression-texts-between'>
                    <div className='big-text'>
                        Penetrometer
                    </div>
                    <div className='large-text'>
                        {penetrometerStr}
                    </div>
                    </div>
                )}
                <LinearGaugeComponent 
                    className='soil-compression-component' 
                    container={ { width:15, type:'RoundedRectangle', backgroundColor: Constants.darkBlue  } } 
                    background={Constants.grey} 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={7} 
                            minimum={0} 
                            majorTicks={{height: 0}} 
                            minorTicks={{height: 0}}
                            labelStyle={{font: {size: '0'}}}
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={penetrometer} width={15} type='Bar' color={gaugeColor}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'7'} x={37} y={15} zIndex='1'>
                        </AnnotationDirective>
                        <AnnotationDirective content={'0'} x={37} y={210} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
            </div>
        </div>
    );
} 

export default SoilCompression;